export class PDFType {
  static readonly BROCHURE = 'brochure'
  static readonly DATASHEET = 'datasheet'
  static readonly REFERENCE_LIST = 'referencelist'
  static readonly SCIENTIFIC_POSTER = 'scientificposter'
  static readonly APP_NOTE = 'appnote'
  static readonly DOWNLOAD = 'download'
}
